import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Breadcrumb, Button, Card, Form, Input, InputNumber, Modal, Table, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import { TextFormat } from 'react-jhipster';
import { getApprovisonnement, rejectedRequest, updateApprovisionnement, validateRequest } from './appro.reducer';

interface Values {
  omMontant: number;
  waveMontant: number;
}

export const FondDashDetails = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;
  const [isValidateModalVisible, setIsValidateModalVisible] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [description, setDescription] = useState('');
  const [form] = Form.useForm();
  const Loading = useAppSelector(state => state.approvisonnement.loading);

  useEffect(() => {
    dispatch(getSession());
    dispatch(getApprovisonnement(props.match.params.id));
  }, []);

  const appro = useAppSelector(state => state.approvisonnement.entity);

  const columns = [
    { title: '', dataIndex: 'label' },
    { title: '', dataIndex: 'value' },
  ];

  const data = [
    { key: '1', label: 'Montant', value: <span>{`${appro.montant} FCFA`}</span> },
    {
      key: '2',
      label: 'Date de la demande',
      value: <TextFormat type="date" value={`${appro.dateEmission}`} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      key: '3',
      label: 'Date de validation',
      value: <TextFormat type="date" value={`${appro.dateValidation}`} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      key: '4',
      label: 'Type Approvisonnement',
      value: (
        <span>
          {appro.typeApprovisonnement === 'COMPTE_BANCAIRE' ? (
            <Tag color="gray">COMPTE BANCAIRE</Tag>
          ) : appro.typeApprovisonnement === 'COMPTE_SCOLARITE' ? (
            <Tag color="green">COMPTE SCOLARITE</Tag>
          ) : null}
        </span>
      ),
    },
    {
      key: '5',
      label: 'Statut',
      value: (
        <span>
          {appro.statutApprovisonnement === 'ENCOURS' ? (
            <Tag color="red">En attente</Tag>
          ) : appro.statutApprovisonnement === 'VALIDE' ? (
            <Tag color="green">Validé</Tag>
          ) : (
            <Tag color="#dc3545">Rejeté</Tag>
          )}
        </span>
      ),
    },
    ...(appro.statutApprovisonnement === 'REJET'
      ? [
          {
            key: '6',
            label: 'Motif',
            value: <span>{`${appro.description}`}</span>,
          },
        ]
      : []),
    ...(appro.statutApprovisonnement === 'VALIDE'
      ? [
          {
            key: '7',
            label: 'Montant Wave',
            value: <span>{`${appro.waveMontant ? appro.waveMontant : 0}  FCFA`}</span>,
          },
          {
            key: '8',
            label: 'Montant Orange',
            value: <span>{`${appro.omMontant ? appro.omMontant : 0} FCFA`}</span>,
          },
        ]
      : []),
  ];

  const handleValidate = (values: Values) => {
    setIsValidateModalVisible(false);
    const entity = {
      ...appro,
      ...values,
    };
    dispatch(validateRequest(entity));
  };

  const handleUpdate = (values: Values) => {
    const entity = {
      ...appro,
      ...values,
    };
    dispatch(updateApprovisionnement(entity));
  };

  const handleReject = async () => {
    try {
      await form.validateFields();
      dispatch(rejectedRequest({ ...appro, description }));
      setIsRejectModalVisible(false);
      setDescription('');
      form.resetFields();
    } catch (error) {
      console.error('rejection échouée :', error);
    }
  };

  function onCreate(values: Values) {
    if (values.omMontant + values.waveMontant !== appro.montant) {
      return Modal.error({
        title: 'Erreur',
        content: "Le montant saisi est différent du montant de l'approvisionnement",
      });
    }
    form.resetFields();
    setIsValidateModalVisible(false);
    handleValidate(values);
  }

  function onUpdate(values: Values) {
    if (values.omMontant + values.waveMontant !== appro.montant) {
      return Modal.error({
        title: 'Erreur',
        content: "Le montant saisi est différent du montant de l'approvisionnement",
      });
    }
    form.resetFields();
    setIsUpdateModalVisible(false);
    handleUpdate(values);
  }

  return (
    <div>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/approvisonnements`}>Approvisonnements</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <div style={{ marginTop: 5 }}>
          <Table sticky columns={columns} dataSource={data} pagination={false} bordered loading={Loading} />
        </div>
        <div style={{ textAlign: 'right', marginTop: 10 }}>
          {appro.statutApprovisonnement === 'ENCOURS' && (
            <>
              <Button type="primary" style={{ marginRight: 8, borderRadius: 16 }} onClick={() => setIsValidateModalVisible(true)}>
                Valider
              </Button>
              <Button
                style={{ backgroundColor: '#dc3545', color: 'white', borderRadius: 16 }}
                onClick={() => setIsRejectModalVisible(true)}
              >
                Rejeter
              </Button>
            </>
          )}
          {appro.statutApprovisonnement === 'VALIDE' && (
            <>
              <Button type="primary" style={{ marginRight: 8, borderRadius: 16 }} onClick={() => setIsUpdateModalVisible(true)}>
                Modifier
              </Button>
            </>
          )}
        </div>
      </Card>

      {/* Validation Modal */}
      <Modal
        title="Confirmer la Validation"
        visible={isValidateModalVisible}
        okText="Valider"
        cancelText="Annuler"
        onOk={() => {
          form
            .validateFields()
            .then(values => {
              onCreate(values);
            })
            .catch(info => {});
        }}
        onCancel={() => {
          form.resetFields();
          setIsValidateModalVisible(false);
        }}
      >
        <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 18 }} layout="horizontal" size="large">
          <Form.Item
            label="Wave"
            name="waveMontant"
            rules={[
              { type: 'number', min: 0 },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber className="form-control" name="wave" min={0} style={{ width: 200 }} controls={false} />
          </Form.Item>
          <Form.Item
            label="OrangeMoney"
            name="omMontant"
            rules={[
              { type: 'number', min: 0 },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber className="form-control" name="om" min={0} style={{ width: 200 }} controls={false} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Rejection Modal */}
      <Modal
        title="Motif du Rejet"
        visible={isRejectModalVisible}
        onOk={handleReject}
        onCancel={() => setIsRejectModalVisible(false)}
        okText="Rejeter"
        cancelText="Annuler"
      >
        <Form form={form} layout="vertical">
          <Form.Item label="Motif du rejet" name="description" rules={[{ required: true, message: 'Veuillez saisir le motif' }]}>
            <Input.TextArea rows={4} value={description} onChange={e => setDescription(e.target.value)} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Update Modal */}
      <Modal
        title="Modifier la Validation"
        visible={isUpdateModalVisible}
        okText="Valider"
        cancelText="Annuler"
        onOk={() => {
          form
            .validateFields()
            .then(values => {
              onUpdate(values);
            })
            .catch(info => {});
        }}
        onCancel={() => {
          form.resetFields();
          setIsUpdateModalVisible(false);
        }}
      >
        <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 18 }} layout="horizontal" size="large">
          <Form.Item
            label="Wave"
            name="waveMontant"
            initialValue={appro.waveMontant}
            rules={[
              { type: 'number', min: 0 },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber className="form-control" name="wave" min={0} style={{ width: 200 }} value={appro.waveMontant} />
          </Form.Item>
          <Form.Item
            label="OrangeMoney"
            name="omMontant"
            initialValue={appro.omMontant}
            rules={[
              { type: 'number', min: 0 },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber className="form-control" type="number" name="om" min={0} style={{ width: 200 }} value={appro.omMontant} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default FondDashDetails;
